@if (!mobile && buttons.length > 0) {
  <div [style.display]="viewportService.innerWidth > 959 ? null : 'none'" class="transition"
    [ngStyle]="{'position': 'absolute', 'top': positionObject.top, 'left': positionObject.left, 'right': positionObject.right, 'bottom': positionObject.bottom }">
    <div style="float:right; width: 64px;">
      @if (sideNav.opened) {
        <button (click)="closeNavbar()" mat-mini-fab color="primary" style="margin: 3px;">
          <mat-icon>
            keyboard_arrow_left
          </mat-icon>
        </button>
      }
      @if (!sideNav.opened) {
        <button (click)="openNavbar()" mat-mini-fab color="primary" style="margin: 3px;">
          <mat-icon>
            keyboard_arrow_right
          </mat-icon>
        </button>
      }
      <!--buttons-->
      @for (button of buttons; track button) {
        @if (!button.children) {
          <button (click)="buttonService.buttonCreateMyComponent(button, false);" mat-mini-fab color="primary" style="margin: 3px;">
            <ng-container>
              <mat-icon>
                {{button.icon}}
              </mat-icon>
            </ng-container>
          </button>
        }
        @if (button.children) {
          <div style="flex-direction: row; width: 100%;">
            <app-expandablebutton [expandTo]="'left'" [button]="button"></app-expandablebutton>
          </div>
        }
      }
    </div>
  </div>
}

<!-- MOBILE -->
<!-- DrawFinishedButtons -->
@if (buttonService.drawfinished && mobile) {
  <div style="position: absolute; top: 10px; right: 5px; z-index: 1000">
    @for (button of buttonService.onDrawFinishedButtons; track button) {
      <button mat-mini-fab color="primary" style="margin: 3px;" (click)="buttonService.onDrawFinishMethods(button)">
        <mat-icon>
          {{button.icon}}
        </mat-icon>
      </button>
    }
  </div>
}

<!-- MOBILE -->
@if (mobile && buttons.length > 0) {
  <div class="transition_mob" style="position: absolute; top: 10px; left: 16px; float: left;">
    <div style="width: 40px; height: 52px;">
      <button (click)="ToggleShowMyChildren();" mat-mini-fab color="primary">
        <mat-icon>
          {{mobileMainButton.icon}}
        </mat-icon>
      </button>
      <mat-icon style="position: relative; left: 7px; bottom: 5px; ">
        arrow_drop_down
      </mat-icon>
    </div>
    @if (showMyChildren) {
      <div @list>
        <button @items (click)="buttonService.putMapInteractionOff();" mat-mini-fab color="primary" style="margin-top: 5px;">
          <mat-icon>
            close
          </mat-icon>
        </button>
        @for (button of buttons; track button) {
          <div @items style="margin-top: 5px;">
            @if (!button.children) {
              <div style="flex-direction: column;">
                <button (click)="buttonService.buttonCreateMyComponent(button, true);" [ngClass]="button == activeButton ? 'activebutton' : ''" mat-mini-fab color="primary">
                  <ng-container>
                    <mat-icon>
                      {{button.icon}}
                    </mat-icon>
                  </ng-container>
                </button>
              </div>
            }
            @if (button.children) {
              <div style="flex-direction: row; width: 100%;">
                <app-expandablebutton [button]="button" [mobile]="true"></app-expandablebutton>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}

